module.exports = __webpack_public_path__ + "static/00022.4df2223c.jpg";